export const FormField = {
  email: 'email',
  confirmation: 'confirmation',
} as const;
